import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const FlexBox = styled('div')(({ theme, color }) => ({
  display: 'flex',
  padding: '15px 70px',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'uppercase',
  border: `3px solid ${color}`,
  color: color,
  fontWeight: theme.fontWeight.bold,
  minWidth: '24px',
  whiteSpace: 'nowrap'
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(5)
}));

export const TabContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const TabHeader = styled('div')(() => ({
  display: 'flex',
  position: 'relative'
}));

export const TabHeaderItem = styled('div')(({ theme, selected }) => ({
  alignItems: 'center',
  background: selected ? 'white' : 'transparent',
  border: `1px solid ${selected ? theme.color.grey[500] : 'transparent'}`,
  borderBottom: 'none',
  color: selected ? theme.color.primary.main : theme.color.default.main,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  fontSize: theme.fontSize.xsmall,
  fontWeight: theme.fontWeight.bold,
  margin: selected ? '-1px 0' : 0,
  padding: theme.spacing(2),
  position: 'relative',
  textAlign: 'center',
  textTransform: 'uppercase',
  width: theme.spacing(30)
}));

export const TabContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  border: `1px solid ${theme.color.grey[500]}`
}));

export const Button = styled(BaseButton)(() => ({
  '@media (max-width: 500px)': {
    alignSelf: 'center'
  },
  padding: '14px',
  marginLeft: '20px',
  marginRight: '10px'
}));

export const FlexContainer = styled('div')(({ $justifyContent, $alignItems, $wrap }) => ({
  display: 'flex',
  justifyContent: $justifyContent || 'normal',
  alignItems: $alignItems || 'normal',
  flex: 1,
  ...($wrap && {
    flexWrap: 'wrap',
    '@media (max-width: 725px)': {
      marginBottom: '10px'
    }
  })
}));
